import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setApiMessage } from "./globalApiMessageSlice";
import { setLoading } from "./loading";
// import axios from "axios";
import axios from "../../GlobalAPIErrorHandler/axiosConfig";

export const getUserGuide = createAsyncThunk(
  "landing/getUserGuide",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    console.log("argKey", arg);
    try {
      const { login } = getState();
      dispatch(setLoading(true));
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token && arg?.guide !== "") {
        const { data } = await axios.get(
          `${API_HOST_SEARCH}/getUserGuideFromCompNumber/${login?.companyNumber}/${arg?.guide}.pdf`,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());
        if (data.responseBody) {
          dispatch(setLoading(false));
          window.open(data?.responseBody?.fileUrl, "_blank");
        }
        return data.responseBody;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// Get user address update pdf
export const getUserAddressUpdate = createAsyncThunk(
  "landing/getUserAddressUpdate",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      dispatch(setLoading(true));
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        const { data } = await axios.get(
          `${API_HOST_SEARCH}/getAccountPageHelpFileFromCompNumber/${login?.companyNumber}`,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());
        if (data.responseBody) {
          dispatch(setLoading(false));
          window.open(data?.responseBody?.fileUrl, "_blank");
        }
        return data.responseBody;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getRecentlyViewedThunk = createAsyncThunk(
  "landing/getRecentlyViewed",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      dispatch(setLoading(true));
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_search}`;
      if (login.token) {
        const { data } = await axios.post(
          `${API_HOST_SEARCH}/templateSearch`,
          { ...arg.payload, userInfo: login?.userInfoAttr?.userInfo },
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());

        return data.responseBody;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getNabCheckThunk = createAsyncThunk(
  "landing/getNabCheckThunk",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      const { compDivId } = login.decodedTokenObject;

      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        const { data } = await axios.get(
          `${API_HOST_SEARCH}/setup/clientConfig/${compDivId}/enable.digitalDownload.shipPrint.nabCheck`,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());

        return data;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    }
  }
);
export const getRecentlyAddedThunk = createAsyncThunk(
  "landing/getRecentlyAdded",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      dispatch(setLoading(true));
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_search}`;
      if (login.token) {
        const { data } = await axios.post(
          `${API_HOST_SEARCH}/templateSearch`,
          { ...arg.payload, userInfo: login?.userInfoAttr?.userInfo },
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        return data.responseBody;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getTagListThunk = createAsyncThunk(
  "landing/getTagList",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      const { companyNumber } = login;
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_search}`;
      if (login.token) {
        const { data } = await axios.get(
          `${API_HOST_SEARCH}/listTags?companyNumber=${companyNumber}&iacCode=${login?.userInfoAttr?.userInfo?.userAttributes?.iac}&subIacCode=${login?.userInfoAttr?.userInfo?.userAttributes?.sub_iac}`,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());

        return data.responseBody;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    }
  }
);

export const getAppVersionThunk = createAsyncThunk(
  "landing/getAppVersionThunk",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();

      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        const { data } = await axios.get(
          `${API_HOST_SEARCH}/setup/clientConfig/key/product_release_version`
        );
        return Object.values(data)[0];
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    }
  }
);

export const getDayCount = createAsyncThunk(
  "email/getDayCount",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      dispatch(setLoading(true));
      const { login } = getState();
      const API_HOST_USER = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        const { compDivId } = login.decodedTokenObject;
        const { data } = await axios.post(
          `${API_HOST_USER}/setup/clientConfig/getDetails/${compDivId}`,
          {
            compDivNumber: compDivId,
            keyId: arg?.payload?.keyId,
          },
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());
        return { ...data, keyId: arg?.payload?.keyId };
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue({ ...error, keyId: arg?.payload?.keyId });
    } finally {
      dispatch(setLoading(false));
    }
  }
);

const landingSlice = createSlice({
  name: "landing",
  initialState: {
    recentlyViewed: [],
    recentlyAdded: [],
    recentlyAddedDone: false,
    tagList: [],
    tagData: null,
    loading: false,
    isSuccess: false,
    rejectedTagList: null,
    relodeLandingPage: 0,
    appVersion: "",
    nabCheck: false,
  },

  reducers: {
    setSelectedCategoryTagId(state, action) {
      const { payload } = action;
      state.tagData = payload;
    },
    removeTags: (state) => {
      state.tagData = null;
    },
    setRelodeLandingPage(state, action) {
      const { payload } = action;
      state.relodeLandingPage = payload;
    },
  },
  extraReducers: {
    [getRecentlyViewedThunk.pending]: (state, { payload }) => {
      state.recentlyViewed = [];
    },
    [getRecentlyViewedThunk.fulfilled]: (state, { payload }) => {
      state.recentlyViewed = payload?.items || [];
    },
    [getRecentlyViewedThunk.rejected]: (state, payload) => {
      state.loading = false;
      state.recentlyViewed = [];
    },
    [getNabCheckThunk.pending]: (state, { payload }) => {
      state.nabCheck = false;
    },
    [getNabCheckThunk.fulfilled]: (state, { payload }) => {
      state.nabCheck = payload?.parameterValue;
    },
    [getNabCheckThunk.rejected]: (state, payload) => {
      state.nabCheck = false;
    },
    [getRecentlyAddedThunk.pending]: (state, { payload }) => {
      state.recentlyAdded = [];
      state.recentlyAddedDone = false;
    },
    [getRecentlyAddedThunk.fulfilled]: (state, { payload }) => {
      state.recentlyAdded = payload?.items || [];
      state.recentlyAddedDone = true;
    },
    [getRecentlyAddedThunk.rejected]: (state, payload) => {
      state.loading = false;
      state.recentlyAdded = [];
      state.recentlyAddedDone = true;
    },
    [getTagListThunk.pending]: (state, { payload }) => {
      state.tagList = [];
      state.rejectedTagList = null;
    },
    [getTagListThunk.fulfilled]: (state, { payload }) => {
      state.tagList = payload;
      state.rejectedTagList = null;
    },
    [getTagListThunk.rejected]: (state, { payload }) => {
      state.loading = false;
      state.tagList = [];
      state.rejectedTagList = payload?.response;
    },
    [getAppVersionThunk.pending]: (state, { payload }) => {},
    [getAppVersionThunk.fulfilled]: (state, { payload }) => {
      state.appVersion = payload;
    },
    [getAppVersionThunk.rejected]: (state, { payload }) => {
      state.appVersion = "";
    },
    [getDayCount.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getDayCount.fulfilled]: (state, { payload }) => {
      if (payload) {
        const { parameterValue = "", parameterKey } = payload;
        let data = [];
        if (parameterValue) {
          if (parameterValue.includes(";")) {
            data = [...data, ...parameterValue.split(";")];
          } else {
            data.push(parameterValue);
          }
        }

        state.loading = false;
        state[parameterKey] = data;
      }
    },
    [getDayCount.rejected]: (state, { payload }) => {
      state.loading = false;
      state[payload.keyId] = [];
    },
  },
});
export const {
  setSelectedCategoryTagId,
  removeTags,
  setRelodeLandingPage,
  setappVersionReact,
} = landingSlice.actions;
export default landingSlice.reducer;
